import { QuizContext } from '@context/QuizContext'
import { Flex, Text } from '@mantine/core'
import React, { useContext } from 'react'

const QuizConcludeWarning = () => {
    const { currentStep } = useContext(QuizContext)
    if (currentStep !== 8) {
        return <></>
    }
    return (
        <Flex
            gap='xs'
            direction={{ xs: 'column', md: 'row' }}
            align='center'
            justify='center'
            mb='lg'
            mt='auto'
        >
            <Text c='text.1' ta='center' display='inline' fw='bold'>
                หมายเหตุ:
            </Text>
            <Text c='text.1' ta='center' display='inline'>
                ผลลัพธ์ที่ได้จากการคำนวณเป็นเพียงตัวเลขประมาณการเท่านั้น
                โดยใช้สูตรคำนวณตามหลักการวางแผนการเงินส่วนบุคคล
            </Text>
        </Flex>
    )
}

export default QuizConcludeWarning
